export const environment = {
   production: true,
   apiUrl: 'https://api.dev.moedas.com.br/',
   tokenMeli: 'APP_USR-883889db-272d-477d-af87-0fa78d4bd96c',
   viaCEP: 'https://viacep.com.br/ws/',
}
